import * as React from 'react';

import type {
  MerchandisingUpsellModule_Location as MerchandisingUpsellModuleLocation,
  MerchandisingUpsellModule_Priority as MerchandisingUpsellModulePriority,
} from '__generated__/graphql-types';

type UpsellPlacementContextType = {
  upsellPlacement: MerchandisingUpsellModulePriority | undefined;
  loading: boolean;
};

const CPlusUpsellPlacementContext = React.createContext<UpsellPlacementContextType>({
  loading: true,
  upsellPlacement: undefined,
});

export const useCourseraPlusUpsellPlacementData = () => {
  return React.useContext(CPlusUpsellPlacementContext);
};

type DataProviderProps = {
  children: React.ReactNode;
  skipQuery?: boolean;
  location: MerchandisingUpsellModuleLocation;
};

/**
 *
 * @param skipQuery use this to pass skip conditions *aside from* the user's logged-in state.
 * This query will automatically skip if the user is not logged in.
 * @returns
 */
const CourseraPlusUpsellPlacementDataProvider = ({ children, skipQuery = false, location }: DataProviderProps) => {
  /**
   * Uncomment once propensity score fallback is fixed
   */
  // const { loading, data } = useQuery<MerchandisingUpsellPriorityData, MerchandisingUpsellPriorityVariables>(
  //   GetMerchandisingUpsellPriority,
  //   {
  //     context: {
  //       clientName: 'gatewayGql',
  //     },
  //     variables: {
  //       location,
  //     },
  //     skip: skipQuery || !isAuthenticatedUser(),
  //   }
  // );

  let upsellPlacement: MerchandisingUpsellModulePriority | undefined;
  if (location === 'RDP') {
    upsellPlacement = undefined;
  } else if (location === 'CAREER_ACADEMY') {
    upsellPlacement = 'LOW';
  } else if (location === 'LIHP') {
    upsellPlacement = undefined;
  }

  return (
    <CPlusUpsellPlacementContext.Provider
      /**
       * Uncomment once propensity score fallback is fixed
       */
      // value={{
      //   loading,
      //   upsellPlacement: data?.MerchandisingUpsellModule?.getMerchandisingUpsell?.priority ?? undefined,
      // }}
      value={{
        loading: false,
        upsellPlacement,
      }}
    >
      {children}
    </CPlusUpsellPlacementContext.Provider>
  );
};

export default CourseraPlusUpsellPlacementDataProvider;
